export default __webpack_public_path__ + "static/media/six-icon.5a642484.svg";